import { useEffect, useMemo } from 'react';

type UseBroadcastChannelProps = {
  channelName: string;
  onMessage?: (data: any) => void;
}

type UseBroadcastChannelReturn = {
  channel: BroadcastChannel;
  postMessage: (message: any) => void;
}

export const useBroadcastChannel = ({ channelName, onMessage }: UseBroadcastChannelProps): UseBroadcastChannelReturn => {
  const channel = useMemo(() => new BroadcastChannel(channelName), [channelName]);
  const postMessage = (message: any) => channel.postMessage(message);

  useEffect(() => {
    if (onMessage) channel.onmessage = evt => onMessage(evt.data);
  }, [onMessage, channel]);

  return { channel, postMessage };
};

export const BROADCAST_CHANNELS = {
  UNDERWRITING_CALCULATOR_SAVED: 'underwriting_calculator_saved',
  DOCUMENT_UPDATED: 'document_updated',
}
